
import React, { useEffect } from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Send } from "lucide-react";
import CreateNotificationForm from "./CreateNotificationForm";
import { useAuth } from "@/context/AuthContext";
import { useCreateNotification } from "@/hooks/useCreateNotification";
import { useIsMobile } from "@/hooks/use-mobile";

interface NotificationsCreateTabProps {
  onCancel: () => void;
}

const NotificationsCreateTab = ({
  onCancel
}: NotificationsCreateTabProps) => {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  
  useEffect(() => {
    if (isMobile) {
      document.body.classList.add('has-mobile-notification');
      document.body.classList.add('form-fixed');
    }
    
    return () => {
      document.body.classList.remove('form-fixed');
    };
  }, [isMobile]);
  
  const handleSuccess = () => {
    setTimeout(() => {
      onCancel();
    }, isMobile ? 300 : 200);
  };
  
  const {
    newNotification,
    isPending,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
    handleInternalCheckboxChange,
    toggleExternalRecipient,
    handleSubmit,
    handleToggleOrderProduct,
    handleOrderProductMessageChange,
    handleOverarchingChange,
    handleUpdateOrderProducts,
  } = useCreateNotification(user?.id, user?.name, handleSuccess);

  return (
    <div className="space-y-3">
      <Card 
        className={isMobile ? "fixed-mobile-card" : ""} 
        style={isMobile ? { 
          position: 'static', 
          transform: 'none', 
          touchAction: 'auto',
          pointerEvents: 'auto'
        } : undefined}
      >
        <CardHeader>
          <CardTitle className="flex items-center">
            <Send className="mr-2 h-5 w-5" />
            Nieuwe melding aanmaken
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CreateNotificationForm
            notification={newNotification}
            isPending={isPending}
            onInputChange={handleInputChange}
            onSelectChange={handleSelectChange}
            onCheckboxChange={handleCheckboxChange}
            onInternalCheckboxChange={handleInternalCheckboxChange}
            onToggleExternalRecipient={toggleExternalRecipient}
            onCancel={onCancel}
            onSubmit={handleSubmit}
            onToggleOrderProduct={handleToggleOrderProduct}
            onOrderProductMessageChange={handleOrderProductMessageChange}
            onOverarchingChange={handleOverarchingChange}
            onUpdateOrderProducts={handleUpdateOrderProducts}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationsCreateTab;
